import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center text-center">
      <div>
        <h1 className="fw-bold text-muted" style={{ fontSize: '64px' }}>404</h1>
        <h2 className="fs-4 mb-2">Page Not Found</h2>
        <p className="text-muted">The page you're looking for doesn't exist.</p>
        <Link to="/" className="btn btn-primary mt-2">
          Go Home
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
